module.exports = __webpack_public_path__ + "static/media/bottom-element-blue.10da6ac0.svg";